import CommonUser from '../../../models/commonUser'

import RoomItem from './roomItem'
export default class RoomLiveDto {
  /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 直播id
     */
  public id: string
    /**
     * @type {number}
     * @memberof RoomLiveDto
     * @name 当周周一时间
     */
    public week: number
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 直播名称
     */
    public title: string
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 届次ID
     */
    public gradeId: string
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 班级id
     */
    public classId: string
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 班级名称
     */
    public clazzName: string
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 课程id
     */
    public courseId: string
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 课程名称
     */
    public courseName: string
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 教室id
     */
    public roomId: string
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 教室编号
      */
    public roomNos: string
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 教室名称
      */
    public roomName: string
    /**
      * @type {number}
      * @memberof RoomLiveDto
      * @name 本周第几天，[1,7]
      */
    public day: number
    /**
      * @type {number}
      * @memberof RoomLiveDto
      * @name 节次
      */
    public lesson: number
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 节次类型
      */
    public category: string
    /**
      * @type {CommonUser[]}
      * @memberof RoomLiveDto
      * @name 教师
      */
    public teachers: CommonUser[]
    /**
      * @type {string[]}
      * @memberof RoomLiveDto
      * @name 教师
      */
      public teacherNames: string[]
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 学科id
      */
    public subjectId: string
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 学科名称
      */
    public subjectName: string
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 直播开始时间
      */
    public beginAt: string
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 直播结束时间
      */
    public endAt: string

    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 关联空间id,英文逗号分隔
      */
    public refSpaceId: string
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 关联空间id列表
      */
    public refSpaceIds: string[]
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 关联空间名
      */
    public refSpaceNames: string

    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 备注
      */
    public remark: string

    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 创建来源，1-课表，2-空间
      */
    public liveSource: string

    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 租户id
      */
    public tenantId: string
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 租户名称
      */
    public tenantName: string
    /**
      * @type {string}
      * @memberof RoomLiveDto
      * @name 关联直播ID
      */
    public refClzIds: string
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name //LIVING-正在直播，UN_START-未开始，END-已结束
     */
    public roomLiveStatus: string
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 创建时间
     */
    public createTime: string
    /**
     * @type {CommonUser}
     * @memberof RoomLiveDto
     * @name 创建人
     */
    public createUser: CommonUser
    /**
     * @type {RoomItem[]}
     * @memberof RoomLiveDto
     * @name 房间列表
     */
    public roomDtos: RoomItem[]
    /**
     * @type {string}
     * @memberof RoomLiveDto
     * @name 类型（PHYSICAL_CLASS,TEACHING_CLASS）
     */
    public classType: string
    constructor({
        id = '',
        week = null,
        title = '',
        gradeId = '',
        classId = '',
        clazzName = '',
        courseId = '',
        courseName = '',
        roomId = '',
        roomNos = '',
        roomName = '',
        day = null,
        lesson = null,
        category = '',
        teachers = [],
        teacherNames = [],
        subjectId = '',
        subjectName = '',
        beginAt = '',
        endAt = '',
        refSpaceId = '',
        refSpaceIds = [],
        refSpaceNames = '',
        remark = '',
        liveSource = '',
        tenantId = '',
        tenantName = '',
        refClzIds = '',
        roomLiveStatus = '',
        createTime = '',
        createUser = null,
        roomDtos = [],
        classType = ''
    } = {}) {
        this.id = id
        this.week = week
        this.title = title
        this.gradeId = gradeId
        this.classId = classId
        this.clazzName = clazzName
        this.courseId = courseId
        this.courseName = courseName
        this.roomId = roomId
        this.roomNos = roomNos
        this.roomName = roomName
        this.day = day
        this.lesson = lesson
        this.category = category
        this.teachers = teachers
        this.teacherNames = teacherNames
        this.subjectId = subjectId
        this.subjectName = subjectName
        this.beginAt = beginAt
        this.endAt = endAt
        this.refSpaceId = refSpaceId
        this.refSpaceIds = refSpaceIds
        this.refSpaceNames = refSpaceNames
        this.remark = remark
        this.liveSource = liveSource
        this.tenantId = tenantId
        this.tenantName = tenantName
        this.refClzIds = refClzIds
        this.roomLiveStatus = roomLiveStatus
        this.createTime = createTime
        this.createUser = createUser
        this.roomDtos = roomDtos
        this.classType = classType
    }
}